import React, { useState } from 'react';
import styles from './FileUpload.module.css';
import AIEduButton from '../Button/AIEduButton';
import { ProgressBar } from 'primereact/progressbar';
import { useIntl } from 'react-intl';
import fileUploadIcon from '../../assets/images/fileUpload.svg';
import { FILE_SIZE_300KB } from '../../utils/Constants';

const FileUpload = ({
    text,
    files,
    setFiles,
    progress,
    setProgress,
    handleFileUpload,
    uploadInProgress,
    errorUpload,
    setErrorUpload,
    errorMessage,
    setUploadInProgress,
    differentFileFormatError,
    setDifferentFileFormatError,
}) => {
    const intl = useIntl();
    const [fileSize, setFileSize] = useState(null);
    const { formatMessage: f } = intl;

    const updateFileSize = (selectedFileSize) => {
        const sizeInKB = (selectedFileSize / 1024).toFixed(2);
        console.log(selectedFileSize);
        if (+sizeInKB === 300) {
            if (selectedFileSize > FILE_SIZE_300KB) setFileSize(300.01);
            else setFileSize(sizeInKB);
        } else {
            setFileSize(sizeInKB);
        }
    };
    const handleFiles = (selectedFiles) => {
        setErrorUpload(false);
        setProgress(0);
        const resetFileData = () => {
            setFiles([]);
            setProgress(0);
            setErrorUpload(false);
            setUploadInProgress(false);
        };
        const selectedFileSize = selectedFiles?.[0]?.size;
        updateFileSize(selectedFileSize);
        if (selectedFiles?.length > 0 && selectedFiles[0].type === 'text/csv') {
            setDifferentFileFormatError('');
            setFiles((prevFiles) => [...Array.from(selectedFiles)]);
        } else if (
            selectedFiles?.length > 0 &&
            selectedFiles[0].type !== 'text/csv'
        ) {
            resetFileData();
            setDifferentFileFormatError(() => f({ id: 'AI_EDU_UPLOAD_VALID_CSV_FILE' }));
        } else {
            resetFileData();
            setDifferentFileFormatError('');
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const droppedFile = e.dataTransfer.files[0];
        if (droppedFile && droppedFile.type === 'text/csv') {
            const selectedFileSize = droppedFile.size;
            updateFileSize(selectedFileSize);
            handleFiles([droppedFile]);
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleFileInput = (e) => {
        handleFiles(e.target.files);
        setTimeout(() => {
            e.target.value = '';
        }, 100);
    };

    const removeFile = (indexToRemove) => {
        setFiles((prevFiles) =>
            prevFiles.filter((_, index) => index !== indexToRemove)
        );
    };

    return (
        <div className={styles.upload_container}>
            <div
                className={styles.drop_zone}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
            >
                <div style={{ height: '100%' }}>
                    <div className={styles.drop_zone_row_1}>
                        <i
                            className={`pi pi-upload mb-2 ${styles.upload_icon}`}
                        />
                        <div>{f({ id: 'AI_EDU_DRAG_N_DROP' })}</div>
                    </div>

                    <div className='flex justify-content-center mt-3 mb-2'>
                        <div className={styles.drop_zone_or_line} />
                        <div className='ml-2 mr-2'>{f({ id: 'AI_EDU_OR' })}</div>
                        <div className={styles.drop_zone_or_line} />
                    </div>
                    <div className={styles.drop_zone_row_2}>
                        <AIEduButton
                            className='btnPrimary'
                            label={f({ id: 'AI_EDU_BROWSE_FILE' })}
                            onClick={() =>
                                document.getElementById('fileInput').click()
                            }
                        />
                        <div
                            className={styles.supported_text}
                        >{f({ id: 'AI_EDU_SUPPORTED_FORMAT' })}</div>
                    </div>
                </div>
                <input
                    type='file'
                    single
                    id='fileInput'
                    style={{ display: 'none' }}
                    onChange={handleFileInput}
                    accept='.csv'
                />
            </div>

            {files.length > 0 ? (
                <>
                    <div>
                        {files.map((file, index) => (
                            <div key={index} className={styles.file}>
                                <div className='flex'>
                                    <div>
                                        <img src={fileUploadIcon} />
                                    </div>
                                    <div className='ml-4'>
                                        <div>{file.name}</div>
                                        <div>
                                            {+fileSize >= 1024
                                                ? `${(fileSize / 1024).toFixed(
                                                      2
                                                  )} MB`
                                                : `${fileSize} KB`}
                                        </div>
                                    </div>
                                </div>
                                <div className='flex align-items-center'>
                                    <ProgressBar
                                        className={styles.file_progress_bar}
                                        value={progress}
                                        showValue={false}
                                        color={
                                            !errorUpload ? '#06b6d4' : '#FF2120'
                                        }
                                    />
                                    {!uploadInProgress && (
                                        <i
                                            className={`pi pi-times ${styles.file_remove_icon}`}
                                            onClick={() => {
                                                removeFile(index);
                                                setProgress(0);
                                            }}
                                        />
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className='flex justify-content-between mt-4'>
                        {errorUpload ? (
                            <div className={styles.error_msg}>
                                {errorMessage}
                            </div>
                        ) : +fileSize > 300 ? (
                            <div className={styles.error_msg}>
                                {f({ id: 'AI_EDU_FILE_EXCEEDS_SIZE_LIMIT' })}
                            </div>
                        ) : (
                            <div></div>
                        )}
                        <AIEduButton
                            label={text}
                            className='btnPrimary'
                            disabled={uploadInProgress || +fileSize > 300}
                            onClick={handleFileUpload}
                        />
                    </div>
                </>
            ) : differentFileFormatError ? (
                <>
                    <div className='flex justify-content-between mt-4'>
                        <div className={styles.error_msg}>
                            {differentFileFormatError}
                        </div>
                        <AIEduButton
                            disabled
                            label={text}
                            className='btnPrimary'
                        />
                    </div>
                </>
            ) : (
                <></>
            )}
        </div>
    );
};

export default FileUpload;
